import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import LightsPanel from '../game/LightsPanel';
import QuestionsContainer from '../game/QuestionsContainer';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import { JButton } from '../ui/JButton';
import FontKeys from '../FontKeys';
import SoundChain from '../ui/SoundChain';
import { transitionScene } from '../SceneTransition';
import JDialog from '../ui/JDialog';
import StateButton from '../ui/StateButton';
import { addJumpAnimationsToSprite } from '../AnimationManager';
import DragOrderScreen from './DragOrderScreen';

export default class QuestionScreen extends Phaser.Scene {
  static get KEY() { return 'QuestionScreen'; }

  init() {
    this.questionTemplates = [
      { id: 0, question: 'Which day comes after X?' },
      { id: 1, question: 'Which day comes before X?' },
      { id: 2, question: 'Yesterday was X.  What is tomorrow?' },
      { id: 3, question: 'Today is X. What day was it yesterday?' },
      { id: 4, question: 'Yesterday was X.  What is today?' },
      { id: 5, question: 'Today is X. What day is it tomorrow?' },
      { id: 6, question: 'What day is # days after X?' }
    ];
    Phaser.Utils.Array.Shuffle(this.questionTemplates);
    this.currentQuestionIndex = 0;
  }

  create() {
    this.soundChain = null;
    this.isJumping = false;
    this.totalAnswersCorrect = 0;
    this.questionLabel = null;

    JButton.instances = [];

    this.background = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._OutsideBckgDays, this).setOrigin(0);

    this.leftDoor = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 62,this.scale.height / 2 - 236 - 11, UIAssetKeys._TempleDoorLeft, this);
    this.rightDoor = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 62,this.scale.height / 2 - 236 - 11, UIAssetKeys._TempleDoorRight, this);

    const templeFront = ABCyaPhaser.Images.addImage(this.scale.width / 2 ,this.scale.height / 2 - 219, UIAssetKeys._TempleWall, this);

    this.lightsPanel = new LightsPanel(this);
    this.add.existing(this.lightsPanel);
    this.lightsPanel.setPosition(-350, -390);

    this.questionsContainer = new QuestionsContainer(this);
    this.questionsContainer.enabled = false;
    this.add.existing(this.questionsContainer);
    this.questionsContainer.x = 0;
    this.questionsContainer.y = 0;

    if (gameData.INSTRUCTIONS1_SEEN) {
      this.startQuestions();
    }
    else {
      gameData.INSTRUCTIONS1_SEEN = true;
      this.time.delayedCall(1000, this.makeDialog, null, this);
    }

    this.jingle = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._Jungle_Theme, this.jingle, 1, true);

    this.speakerButton = new StateButton(this, UIAssetKeys._UnmuteBtnDays, UIAssetKeys._MuteBtn);
    this.speakerButton.x = this.scale.width - 40;
    this.speakerButton.y = this.scale.height - 40;
    this.add.existing(this.speakerButton);

    this.speakerButton.doAction1 = () => {
      this.jingle.mute = false;
      gameData.muteJingle = false;
    };
    this.speakerButton.doAction2 = () => {
      this.jingle.mute = true;
      gameData.muteJingle = true;
    };

    if (gameData.muteJingle) {
      this.jingle.mute = true;
      this.speakerButton.switchStateOff();
    }
  }

  startQuestions () {
    this.createMan();
    this.makeQuestion();

    this.time.delayedCall(2000, () => this.questionsContainer.enabled = true);
    this.questionsContainer.doAction = this.guessMade.bind(this);
    this.questionsContainer.doQuestionClick = this.questionClicked.bind(this);
  }

  createMan () {
    // create static man
    this.jumpAnimation = this.add.sprite(0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._jump_1);
    this.jumpAnimationContainer = this.add.container(-this.jumpAnimation.width / 2, -this.jumpAnimation.height / 2, this.jumpAnimation);
    addJumpAnimationsToSprite(this.jumpAnimation);

    this.moveManToStart();
  }

  moveManToStart () {
    // always make man be on top of questions which are newly generated
    this.children.bringToTop(this.jumpAnimation);

    this.jumpAnimation.alpha = 1;

    this.jumpAnimation.x = -100;
    this.jumpAnimation.y = 500;

    // perform jump
    this.isJumping = true;

    this.jumpAnimation.play('Jump');

    const y = 768 - this.jumpAnimation.height / 2 - 20;
    const x = (this.scale.width / 2 - 70) + 50;

    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 700, { delay: 400, x, y }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));
    this.time.delayedCall(700, () => ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Jump_Land, this));

    JButton.cycleBrightness();
  }

  makeQuestion () {
    /*
    x Which day comes after X?
    x Which day comes before X?
    x Yesterday was X. What is tomorrow?
     Yesterday was X. What is today?
     x Today is X. What day was it yesterday?
     Today is X. What day is it tomorrow?
     What day is # days after X?
     */

    if (this.questionLabel) {
      const oldQuestionLabel = this.questionLabel;
      ABCyaPhaser.Tweens.addTween(this.questionLabel, 600, { alpha: 0 }, Phaser.Math.Easing.Linear, () => oldQuestionLabel.destroy());
    }

    /** @type {{id: number, question: string}} */
    const questionObj = this.questionTemplates[this.currentQuestionIndex];
    this.currentQuestionIndex = this.currentQuestionIndex + 1;
    if (this.currentQuestionIndex >= this.questionTemplates.length) {
      this.currentQuestionIndex = 0;
      Phaser.Utils.Array.Shuffle(this.questionTemplates);
    }
    const questionTemplate = questionObj.question;

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const randIndexDays = Phaser.Math.Between(0, days.length - 1);
    const day = days[randIndexDays];

    let question = questionTemplate.replace('X', day);

    this.answer = null;
    let newIndex = 0;

    const soundChainArray = [];

    // determine correct answer for each of the set of 7 questions
    if (questionObj.id === 0) {
      newIndex = randIndexDays + 1;
      if (newIndex === 7) {
        newIndex = 0;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_1');
      soundChainArray.push(day);
    }
    else if (questionObj.id === 1) {
      newIndex = randIndexDays - 1;
      if (newIndex === -1) {
        newIndex = days.length - 1;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_2');
      soundChainArray.push(day);
    }
    else if (questionObj.id === 2) {
      newIndex = randIndexDays + 2;
      if (newIndex > 6) {
        newIndex = newIndex - 7;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_3_1');
      soundChainArray.push(day);
      soundChainArray.push('Question_3_2');
    }
    else if (questionObj.id === 3) {
      newIndex = randIndexDays - 1;
      if (newIndex === -1) {
        newIndex = days.length - 1;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_5_1');
      soundChainArray.push(day);
      soundChainArray.push('Question_5_2');
    }
    else if (questionObj.id === 4) {
      newIndex = randIndexDays + 1;
      if (newIndex === 7) {
        newIndex = 0;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_4_1');
      soundChainArray.push(day);
      soundChainArray.push('Question_4_2');
    }
    else if (questionObj.id === 5) {
      newIndex = randIndexDays + 1;
      if (newIndex === 7) {
        newIndex = 0;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_6_1');
      soundChainArray.push(day);
      soundChainArray.push('Question_6_2');
    }
    else if (questionObj.id === 6) {
      const rand = Phaser.Math.Between(2,7);
      const numberNames = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven'];

      question = question.replace('#', rand);

      newIndex = randIndexDays + rand;
      if (newIndex > 6) {
        newIndex = newIndex - 7;
      }
      this.answer = days[newIndex];

      soundChainArray.push('Question_7_1');
      soundChainArray.push(numberNames[rand]);
      soundChainArray.push('Question_7_2');
      soundChainArray.push(day);
    }

    this.questionLabel = ABCyaPhaser.Text.addText(this.scale.width / 2,this.scale.height / 2 - 16,'20pt', 0xFFF4B6, FontKeys._rifficregular, question, this).setOrigin(0.5,0);

    // underneath adventure man
    this.children.moveBelow(this.questionLabel, this.jumpAnimationContainer);

    this.questionLabel.alpha = 0;

    this.soundChain = new SoundChain(this, soundChainArray);
    ABCyaPhaser.Tweens.addTween(this.questionLabel, 2000, { delay: 1600, alpha: 1, onStart: () => this.soundChain.play() }, Phaser.Math.Easing.Linear);
  }

  /**
   * 
   * @param {JButton} button 
   */
  guessMade (button) {
    const dayChosen = button.name.replace('Btn','');

    let isCorrect = false;

    if (this.answer === dayChosen) {
      isCorrect = true;

      this.totalAnswersCorrect++;
    }

    this.soundChain.stop(!isCorrect);

    this.jump(button.x, button.y, isCorrect);

    button.makeBright();
  }

  jump (x, y, isAnswerCorrect) {
    if (this.jumpAnimation === null) return;

    // disable more Days button clicking when button just clicked
    this.questionsContainer.disable();

    this.isJumping = true;

    this.jumpAnimation.play('Jump');

    // eslint-disable-next-line no-param-reassign
    y -= this.jumpAnimation.height / 2 - 20;
    // eslint-disable-next-line no-param-reassign
    x -= 15;

    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 700, { x,y, delay: 400 }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Jump_Land, this, 1, false, 0.7);

    if (isAnswerCorrect) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Correct_Answer, this, 1, false, 1);

      if (this.totalAnswersCorrect === 10) {
        ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 350, { scale: 1.08, delay: 400, yoyo: true }, Phaser.Math.Easing.Linear, () => {
          this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1);
          this.lightsPanel.turnOnNextLight();
          this.time.delayedCall(250, this.doWinSequence, null, this);
        });

        return;
      }

      ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 350, { delay: 400, scale: 1.08, yoyo: true }, Phaser.Math.Easing.Linear, () => {
        this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1);
        this.lightsPanel.turnOnNextLight();
        this.makeQuestion();
      });
    }
    else {
      ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 350, { delay: 400, scale: 1.08, yoyo: true }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Incorrect_Answer, this, 1, false, 1);
    }

    this.time.delayedCall(3000, this.moveManToFront, null, this);
    this.time.delayedCall(4300, () => this.questionsContainer.enable());
  }

  doWinSequence () {
    // when man exits through door, make it look like he went in
    // by making him appear under top of door
    this.children.bringToTop(this.lightsPanel);

    this.time.delayedCall(10, this.manJumpFrontTemple, null, this);
    this.time.delayedCall(210, this.openDoors, null, this);
    this.time.delayedCall(3210, this.cleanUp, null, this);
  }

  manJumpFrontTemple () {
    this.jumpOnly(this.scale.width / 2, 300, false);
  }

  jumpOnly (x, y) {
    if (this.jumpAnimation === null) return;

    // disable more Days button clicking when button just clicked
    this.questionsContainer.disable();

    this.isJumping = true;
    this.jumpAnimation.play('Jump');

    // eslint-disable-next-line no-param-reassign
    y -= this.jumpAnimation.height / 2 - 20;
    // eslint-disable-next-line no-param-reassign
    x -= 15;

    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 700, { delay: 400, x,y }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Jump_Land, this, 1, false, 0.7);
  }

  openDoors () {
    ABCyaPhaser.Tweens.addTween(this.leftDoor, 4000, { x: this.leftDoor.x - 100 }, Phaser.Math.Easing.Bounce.Out);
    ABCyaPhaser.Tweens.addTween(this.rightDoor, 4000, { x: this.rightDoor.x + 100 }, Phaser.Math.Easing.Bounce.Out);

    this.time.delayedCall(2000, this.manJumpThroughDoor, null, this);
  }

  manJumpThroughDoor () {
    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 2500, { x: this.scale.width / 2, y: -450 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 2500, { y: -200, scale: 0.3 }, Phaser.Math.Easing.Linear);
    });
  }

  cleanUp () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Iris_Transition, this);
    this.jingle.stop();
    this.jingle.destroy();

    transitionScene(this, DragOrderScreen.KEY, 'radial');
  }

  moveManToFront () {
    // always make man be on top of questions which are newly generated
    this.children.bringToTop(this.jumpAnimation);

    this.jumpAnimation.alpha = 1;

    // perform jump
    this.isJumping = true;
    this.jumpAnimation.play('Jump');

    const y = 768 - this.jumpAnimation.height / 2 - 20;
    const x = (this.scale.width / 2 - 70) + 50;

    ABCyaPhaser.Tweens.addTween(this.jumpAnimation, 700, { delay: 400, x,y }, Phaser.Math.Easing.Linear, () => this.jumpAnimation.stop().setFrame(UIAssetKeys._jump_1));

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Jump_Land, this, 1, false, 0.7);

    JButton.cycleBrightness();
  }

  questionClicked () {
    if (this.soundChain !== null && !this.soundChain.isPlaying()) {
      this.soundChain.playAgain();
    }
  }

  makeDialog () {
    this.dialog = new JDialog(this,UIAssetKeys._PopupBckg,UIAssetKeys._ContinueBtnDays,null, null, false);
    this.dialog.doAction1 = this.continueClicked.bind(this);
    this.dialog.setPosition(this.scale.width / 2, this.scale.height / 2 + 250);
    this.dialog.button1.x += 270;
    this.dialog.button1.y -= 145;

    this.dialog.y += 700;
    this.add.existing(this.dialog);

    this.text1 = ABCyaPhaser.Text.addText(-60, -20, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'Answer the questions correctly', this.dialog).setOrigin(0.5, 0);
    this.text2 = ABCyaPhaser.Text.addText(-96, 20, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'to unlock the temple door!', this.dialog).setOrigin(0.5, 0);
    this.text2 = ABCyaPhaser.Text.addText(-115, 80, '24pt', 0xFFF4B6, FontKeys._rifficregular, 'Let\'s get that treasure!', this.dialog).setOrigin(0.5, 0);

    const yAdjust = 726;

    ABCyaPhaser.Tweens.addTween(this.dialog, 2000, { delay: 500, y: this.dialog.y - yAdjust }, Phaser.Math.Easing.Bounce.Out);

    this.instructionsAudio = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._2_Answer_Questions_Correctly, this.instructionsAudio, 1, false, 1.5);
  }

  continueClicked () {
    this.instructionsAudio.stop();
    this.instructionsAudio.destroy();
    this.instructionsAudio = null;

    if (this.dialog) {
      const yAdjust = 726;
      this.dialog.enabled = false;

      ABCyaPhaser.Tweens.addTween(this.dialog, 2000, { y: this.dialog.y + yAdjust, completeDelay: 100 }, Phaser.Math.Easing.Linear, () => this.startQuestions());
    }
  }
}